import { EmptyView } from "./styles";

export default function DisplayMessage({ uiconstants, message, marginTop, paddingBottom }) {
  return (
    <EmptyView
      data-testid="empty-view"
      uiconstants={uiconstants}
      marginTop={marginTop}
      paddingBottom={paddingBottom}
    >
      {message}
    </EmptyView>
  );
}
